import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import classNames from 'classnames';

import './container.scss';

const Container: React.FC<{className?: string;}> = ({ className, children }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div
            className={classNames({
                'container-wrapper': true,
                'container-wrapper--m': api.getDevice() === 'mobile',
                [`${className}`]: !!className
            })}
        >
            {children}
        </div>
    );
};

export default Container;
